import { Button, DialogContentText, Theme, Typography, WithStyles, createStyles, withStyles } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';


export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const styles = (theme: Theme) => (
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
)

export const DialogTitle = withStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: 545,
    textAlign: 'center',

  },

}))(MuiDialogTitle);

export const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center',

  },
}))(MuiDialogContent);

export const TypographyDialogTitle = withStyles((theme: Theme) => ({
  root: {
    fontSize: 18,
    fontWeight: 500,
    color: '#7F7F7F'
  },
}))(Typography);

export const TypographyDialogContent = withStyles((theme: Theme) => ({
  root: {
    fontSize: 15,
    fontWeight: 500,
    color: '#7F7F7F'
  },
}))(DialogContentText);

export const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 15,
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  }
}))(MuiDialogActions);


export const ButtonOutlined = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 8,
    border: 'solid 1px #E94E1B',
    fontFamily: '"Roboto", "Montserrat"',
    color: '#E94E1B',
    backgroundColor: '#FFF',
    '&:hover': {
      backgroundColor: '#FFF',
      border: 'solid 1px #E94E1B',
    }
  },
  
}))(Button);

export const ButtonContained = withStyles((theme: Theme) => ({
  root: {
    borderRadius: 8,
    border: 'solid 1px #E94E1B',
    fontFamily: '"Roboto", "Montserrat"',
    color: '#FFF',
    backgroundColor: '#E94E1B',
    '&:hover': {
      backgroundColor: '#E94E1B',
      border: 'solid 1px #E94E1B',
    }
  },
  
}))(Button);